import api, { cityApi } from 'lib/api'
import { to } from 'nh-utils'
import filters from 'lib/filters'

export const getLocalities = () => to(cityApi.get('/city'))

export const searchById = id => to(api.get(`/estates?id=${id}`))

export const getFilters = () => filters
